'use client';;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/qr-codes\",\"regex\":\"^/([^/]+)/dashboard/qr-codes$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/qr-codes/:id\",\"regex\":\"^/([^/]+)/dashboard/qr-codes/([^/]+)$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/qr-codes/:id/edit\",\"regex\":\"^/([^/]+)/dashboard/qr-codes/([^/]+)/edit$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/settings/api-keys\",\"regex\":\"^/([^/]+)/dashboard/settings/api-keys$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/settings/billing\",\"regex\":\"^/([^/]+)/dashboard/settings/billing$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/settings/domains\",\"regex\":\"^/([^/]+)/dashboard/settings/domains$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/settings/profile\",\"regex\":\"^/([^/]+)/dashboard/settings/profile$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/settings/security\",\"regex\":\"^/([^/]+)/dashboard/settings/security$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/tags\",\"regex\":\"^/([^/]+)/dashboard/tags$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/templates\",\"regex\":\"^/([^/]+)/dashboard/templates$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/dashboard/templates/:id/edit\",\"regex\":\"^/([^/]+)/dashboard/templates/([^/]+)/edit$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/disabled\",\"regex\":\"^/([^/]+)/disabled$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/features\",\"regex\":\"^/([^/]+)/features$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/plans\",\"regex\":\"^/([^/]+)/plans$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/s/:token\",\"regex\":\"^/([^/]+)/s/([^/]+)$\",\"paramNames\":[\"locale\",\"token\"],\"hasOptionalPrefix\":true},{\"path\":\"/docs/:slug*?\",\"regex\":\"^/docs(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/imprint\"},{\"path\":\"/privacy-policy\"}],\"isrRoutes\":[\"/docs/:slug*?\"]}";globalThis["_sentryNextJsVersion"] = "16.4.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";

// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { env } from './env';

Sentry.init({
	enabled: process.env.NODE_ENV === 'production',
	dsn: env.NEXT_PUBLIC_SENTRY_DSN,
	environment: env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

	// Add optional integrations for additional features
	integrations: [Sentry.replayIntegration()],

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: 1,

	// Define how likely Replay events are sampled.
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	// Define how likely Replay events are sampled when an error occurs.
	replaysOnErrorSampleRate: 1.0,

	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: false,

	// Filter out errors caused by browser extensions and third-party scripts
	beforeSend(event) {
		const errorMessage = event.exception?.values?.[0]?.value || '';

		// Filter out DOM manipulation errors caused by browser extensions
		// (Grammarly, translation tools, ad blockers, etc.)
		if (
			errorMessage.includes("Failed to execute 'removeChild' on 'Node'") ||
			errorMessage.includes("Failed to execute 'insertBefore' on 'Node'") ||
			errorMessage.includes("Failed to execute 'appendChild' on 'Node'") ||
			errorMessage.includes('The node to be removed is not a child of this node')
		) {
			return null;
		}

		// Filter out errors from browser extensions
		const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
		const isFromExtension = frames.some(
			(frame) =>
				frame.filename?.includes('extension://') ||
				frame.filename?.includes('moz-extension://') ||
				frame.filename?.includes('chrome-extension://'),
		);
		if (isFromExtension) {
			return null;
		}

		return event;
	},
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
